module.exports = __webpack_public_path__ + "img/car.72a474e3.png";